<template>
    <div>
        <van-action-sheet
                v-model="showChooseMakePoster"
                style="border-bottom: 1px solid #eeeeee"
        >
            <div style="margin-bottom: 5px; text-align: center; font-size: 17px; ">

                <div style="padding: 10px 0px;" @click="showMiniAppSharePop">
                    <div>商品海报-小程序</div>
                    <div style="font-size: 10px; color: #aaaaaa;">扫码进入小程序购买商品，新粉丝需先注册</div>
                </div>
                <div style="height: 1px; background-color: #eeeeee"></div>
                <div style="padding: 10px 0px;" @click="showNormalSharePop">
                    <div>商品海报</div>
                    <div style="font-size: 10px; color: #aaaaaa;">扫码可直接购买商品</div>
                </div>
                <div style="height: 6px; background-color: #eeeeee"></div>
                <div style="padding: 15px 0px;" @click="showChooseMakePoster = false">取消</div>
            </div>

        </van-action-sheet>

        <Wp_share_poster :share-url="newLink"
                         :activeShow="show_share_pop"
                         :use-to="shareUseTo"
        >
            <div style="text-align: left">

                <Wp_image v-if="posterImg" :url="posterImg" width="100%"/>
                <Wp_image v-else-if="share_img_url" :url="share_img_url" width="100%"/>

                <div style="font-size: 15px; font-weight: bold">
                    <span>
                        <van-tag type="danger" style="font-size: 12px; padding: 0px 6px" v-if="skuInfo.merchant_type === 3">拼多多旗舰店</van-tag>
                        <van-tag type="danger" style="font-size: 12px; padding: 0px 6px" v-else-if="skuInfo.merchant_type === 4">拼多多专卖店</van-tag>
                        <van-tag type="danger" style="font-size: 12px; padding: 0px 6px" v-else-if="skuInfo.merchant_type === 5">拼多多专营店</van-tag>
                        <van-tag type="danger" style="font-size: 12px; padding: 0px 6px" v-else>拼多多</van-tag>
                    </span>
                    {{skuInfo.goods_name}}
                </div>
<!--                <div style="text-align: right; color: #666666">-->
<!--                    评论数 {{skuInfo.comments}}&nbsp;&nbsp;-->
<!--                    好评率 {{skuInfo.goodCommentsShare}}%-->
<!--                </div>-->

            </div>
            <div slot="text" style="min-height: 80px; font-weight: normal; margin-top: 3px">

                <div style="color:red; font-size: 15px">
                    <div v-if="couponData && couponData.discount">
                        <div>
                            内购价 ¥
                            <span style="font-size: 22px; font-weight: bold">{{(Number(skuInfo.min_group_price / 100) - Number(couponData.discount)).toFixed(2)}}</span>
                        </div>
                        <div style="color: #999999">
                            原价 <span style="text-decoration:line-through;">¥ {{skuInfo.min_group_price / 100}}</span>

                            <span style="color: #FF0000; ">&nbsp;&nbsp;&nbsp;优惠券  ¥ <span style="font-size: 18px">{{couponData.discount}}</span></span>
                        </div>
                    </div>
                    <div v-else>
                        价格 ¥ <span style="font-size: 22px; font-weight: bold">{{skuInfo.min_group_price / 100}}</span>
                        <div>&nbsp;</div>
                    </div>
                    <!--                                    <div style="text-align: left; color: #666666; margin-top: 2px">-->
                    <!--                                        评论数 {{skuInfo.comments}}&nbsp;&nbsp;-->
                    <!--                                        好评率 {{skuInfo.goodCommentsShare}}%-->
                    <!--                                    </div>-->

<!--                    <div v-if="$store.state.wx_name && $store.state.wx_name !== 'null'">-->
<!--                        <van-cell style="padding: 0px; margin: 0px" :border="false">-->
<!--&lt;!&ndash;                            <van-image slot="icon" :src="$store.state.wx_img" round style="width: 45px;" fit="contain"/>&ndash;&gt;-->
<!--                            <img slot="icon" :src="$store.state.wx_img" width="40px" height="40px" style="border-radius: 50%;">-->
<!--                            <div slot="title" style="margin-left: 10px; font-size: 13px; margin-top: 10px;">-->
<!--                                <div>-->
<!--                                    <span style="font-size: 18px;">好友{{$store.state.wx_name}}</span>-->
<!--                                </div>-->
<!--                                <div>-->
<!--                                    <span style="font-size: 13px;">推荐您享受京东购物内购优惠</span>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                        </van-cell>-->
<!--                    </div>-->
<!--                    <div v-else>-->
<!--                        <van-cell style="padding: 0px" :border="false">-->
<!--                            <van-icon slot="icon" name="user-circle-o" size="45"></van-icon>-->
<!--                            <div slot="title" style="margin-left: 10px; font-size: 13px; margin-top: 10px;">-->
<!--                                <div>-->
<!--                                    <span style="font-size: 18px">您的好友</span>-->
<!--                                </div>-->
<!--                                <div>-->
<!--                                    <span style="font-size: 13px;">推荐您享受京东购物内购优惠</span>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                        </van-cell>-->
<!--                    </div>-->

                    <div style="margin-top: 5px; color:red; font-size: 15px; text-align: left">
                        万品京选
                        <span style="font-size: 13px; color: #999999">拼多多社交电商战略合作伙伴</span>
                    </div>

                </div>
            </div>
            <div slot="bottom">
                <div style="color: #888888; font-size: 11px; margin-right: 2px; text-align: right">长按识别二维码</div>
            </div>
            <!--                            <div slot="bottom" style="margin-top: 5px; color:red; font-size: 15px; text-align: left">-->
            <!--                                万品京选-->
            <!--                                <span style="font-size: 13px; color: #999999">京东社交电商战略合作伙伴</span>-->
            <!--                            </div>-->
        </Wp_share_poster>
        <van-popup v-model="showLoading">

            <van-loading type="spinner" color="#1989fa" vertical
                         style="padding: 30px;">
                <div slot="default" style="text-align: center">海报制作中<br>&nbsp;请稍后...</div>
            </van-loading>

        </van-popup>
    </div>
</template>

<script>
    import Wp_image from "../../custom/Wp_image";
    import {Toast} from "vant";
    import Wp_share_poster from "../../custom/Wp_share_poster";
    export default {
        name: "Wp_pdd_skuinfo_poster",
        components: {Wp_share_poster, Wp_image},
        props:{
            skuInfo: {type: Object, default: null},
            couponData: {type: Object, default: null},
            posterImg: {type: String, default: ""}
        },

        data(){
            return{
                newLink: '',
                share_img_url: "",
                show_share_pop: '',

                showChooseMakePoster: false,

                shareUseTo: "",

                showLoading: false,
            }
        },

        mounted(){
            this.share_img_url = this.skuInfo.goods_image_url;
        },

        methods:{
            showSharePop() {
                this.showChooseMakePoster = true;

                if(!this.$common.gloabl_wx_mini_user_info || !this.$common.gloabl_wx_mini_user_info.u_code){
                    this.showNormalSharePop();
                }

                // this.$wx.miniProgram.getEnv(res => {
                //     if (!res.miniprogram) {
                //         this.showNormalSharePop();
                //     }
                // });

                // this.showNormalSharePop();
            },

            /**
             * 制作普通海报
             */
            showNormalSharePop() {
                this.showChooseMakePoster = false;
                this.shareUseTo = "";
                this.showLoading = true;
                this.makeLinks(()=> {
                    this.showLoading = false;
                    let timestamp = "_" + Date.parse(new Date());
                    this.show_share_pop = timestamp;
                })
                // this.$log(JSON.stringify(this.skuInfo))
            },

            /**
             * 制作小程序海报
             * @param skuId
             */
            showMiniAppSharePop(){
                if(this.skuInfo && this.skuInfo.goods_sign){
                    let _skuId = this.skuInfo.goods_sign;
                    let _search_id = this.skuInfo.search_id;
                    let pdd_ids = {
                        skuId: _skuId,
                        search_id: _search_id
                    }
                    this.showChooseMakePoster = false;
                    this.shareUseTo = "mini_app";
                    this.showLoading = true;
                    this.getQrcodeUrl(pdd_ids, qr_img_url=>{
                        this.newLink = qr_img_url;
                        let timestamp = "_" + Date.parse(new Date());
                        this.show_share_pop = timestamp;
                    })
                }
            },

            getQrcodeUrl(pdd_ids, fn){
                if(this.$common.gloabl_wx_mini_user_info){
                    let u_code = this.$common.gloabl_wx_mini_user_info.u_code;
                    // let u_code = "d60ba6";

                    let params = {
                        app_id: this.$common.wx_app_id,
                        app_secret: this.$common.wx_app_secret,
                        scene: u_code + ";" + 'pdd:' + pdd_ids.skuId,
                        width: 300
                    };

                    if(params.scene.length > 32){
                        let _short_params = {
                            url: params.scene
                        };
                        //使用短链的形式存储scene
                        this.$saveShortUrl(_short_params, res=>{
                            if(res && res.data && res.data.id){
                                params.scene = "short_" + res.data.id;

                                this.$getWxAppQrcode(params, response =>{
                                    this.$log(response)
                                    if(response && response.data){
                                        this.showLoading = false;
                                        let qr_img_url = response.data;
                                        if (qr_img_url) {
                                            if(fn){
                                                fn(qr_img_url);
                                            }
                                        }
                                    }else{
                                        this.showLoading = false;
                                        this.$dialog.alert({
                                            message: "邀请海报制作失败，请重试"
                                        })
                                    }
                                })
                            }
                        });
                    }else{
                        this.$getWxAppQrcode(params, response =>{
                            this.$log(response)
                            if(response && response.data){
                                this.showLoading = false;
                                let qr_img_url = response.data;
                                if (qr_img_url) {
                                    if(fn){
                                        fn(qr_img_url);
                                    }
                                }
                            }else{
                                this.showLoading = false;
                                this.$dialog.alert({
                                    message: "邀请海报制作失败，请重试"
                                })
                            }
                        })
                    }
                }
            },


            makeLinks(fn) {

                if(this.skuInfo && this.skuInfo.goods_sign){
                    let params = this.$getExtendLinkParams_pdd();
                    params.pid = this.$common_pdd.getPddPid();
                    params.goods_sign_list = this.skuInfo.goods_sign;
                    params.search_id = this.skuInfo.search_id;

                    this.$getExtendLink_pdd(params, response=>{
                        this.$log(response)
                        if(response && response.code === 200){
                            if(response.data && response.data.goods_promotion_url_generate_response
                                && response.data.goods_promotion_url_generate_response.goods_promotion_url_list
                                && response.data.goods_promotion_url_generate_response.goods_promotion_url_list.length > 0){

                                this.newLink = response.data.goods_promotion_url_generate_response.goods_promotion_url_list[0].short_url;

                                if (fn) {
                                    fn(this.newLink)
                                }
                                //
                                // if(this.skuInfo.goods_image_url){
                                //     this.share_img_url = this.skuInfo.goods_image_url;
                                // }
                            }else{
                                this.showLoading = false;
                                Toast.fail({
                                    message: '生成推广链接失败'
                                })
                            }
                        }else{
                            this.showLoading = false;
                            Toast.fail({
                                message: '生成推广链接异常'
                            })
                        }
                    });
                }

            },
        }
    }
</script>

<style scoped>

</style>